<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        {{title}} Viewer
      </h2>
      <p class="tw-italic tw-text-gray-700">
        View RAW data for various cases/forms.
      </p>
    </b-container>

    <hr>

    <!-- CSV download -->
    <b-row>
      <b-col>
        <small>Total Results: {{ options.totalRows }} <i @click="downloadFile" class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download All"></i></small>
      </b-col>
    </b-row>

    <b-table
      ref="table"
      striped
      hover
      responsive
      selectable
      select-mode='single'
      @row-selected="onRowSelected"
      :items="myProvider"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    ></b-table>

    <b-pagination
      v-if="options.totalRows"
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>

    <b-modal id="modal-1" size="lg" scrollable title="Details">
      <b-table
      responsive
      stacked
      :items="modal_items"
      :fields="modal_fields"
    ></b-table>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import { mapState } from "vuex";

import { each } from 'lodash';

const studyName = process.env.VUE_APP_STUDY;

export default {
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 10,
        perPage: 20
      },
      loading: false,
      search: "",
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      selected: null,
      modal_items: [],
      modal_fields: []
    };
  },
  computed: {
    ...mapState("websheet", ["view"])
  },
  watch: {
    view: function() {
      this.$refs.table.refresh();
    }
  },
  methods: {
    myProvider(ctx) {
      this.$bvModal.hide('modal-1');

      const that = this;

      return HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/generic-data/', {
        params: {
          view: that.view,
          page: ctx.currentPage,
          count: ctx.perPage,
          sortBy: that.sortBy,
          sortDesc: that.sortDesc ? "" : "yes"
        }
      })
        .then(response => {
          let fields = [];
          each(response.data.fields, function(field) {
            fields.push({
              key: field,
            });
          });
          that.fields = fields;
          that.modal_fields = response.data.modal_fields;
          that.data = response.data.data;
          that.title = response.data.title;
          that.options.totalRows = parseInt(response.data.total);
          return that.data;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          return [];
        });
    },
    onRowSelected(items) {
      let that = this;
      that.modal_items = items;
      this.$bvModal.show('modal-1');
    },
    beforeRouteLeave(to, from, next) {
      this.$bvModal.hide('modal-1');
      next();
    },
    downloadFile: function(){
      const that = this;
      let params = {
        view: that.view,
        return_as: 'csv',
      }
      HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/generic-data/', {params: params}).then(response => {
          var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", params.view + ".csv");
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },

  }
};
</script>

<style>
</style>